import React, { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import HowItWorksSection from './components/HowItWorksSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  return (
    <div className="App">
      {showTerms ? (
        <TermsOfService onClose={() => setShowTerms(false)} />
      ) : showPrivacy ? (
        <PrivacyPolicy onClose={() => setShowPrivacy(false)} />
      ) : (
        <>
          <Navbar />
          <HeroSection />
          <StatsSection />
          <HowItWorksSection />
          <TestimonialsSection />
          <FAQSection />
          <CTASection />
          <Footer 
            onOpenTerms={() => setShowTerms(true)} 
            onOpenPrivacy={() => setShowPrivacy(true)} 
          />
          <Toaster />
        </>
      )}
    </div>
  );
}

export default App;